











































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { Getter, Action, State } from 'vuex-class';
import { PaymentSources, PaymentSourcesAddMethod } from '@/common/Payments';
import BillPay from '@/services/BillPay';
import Brand from '@/services/Brand';
import { captureException } from '@sentry/browser';
import { loadStripe, Stripe } from '@stripe/stripe-js';

import Welcome from '@/components/Global/Welcome.vue';
import Loading from '@/components/Global/Loading.vue';
import Card from '@/components/Global/Card.vue';
import Alert from '@/components/Global/Alert.vue';
import addPaymentMethod from '@/components/Payment/Methods/AddPaymentMethod.vue';

import Source from '@/components/Payment/Methods/Source.vue';
import jQuery from 'jquery';
import uuid from 'uuid/v4';

@Component({
	name: 'PaymentMethods',
	components: {
		Welcome,
		Loading,
		Card,
		Source,
		addPaymentMethod,
		Alert,
	},
})
export default class PaymentMethods extends Vue {
	@Getter('payment_sources', { namespace: 'Payment' }) private paymentSources: PaymentSources[];
	@Action('setPaymentSources', { namespace: 'Payment' }) private setPaymentSources: () => void;
	@State('addedPaymentSuccess', { namespace: 'Payment' }) private addedPaymentSuccess: boolean;
	@State('removePaymentSuccess', { namespace: 'Payment' }) private removePaymentSuccess: boolean;
	@State('verifyPaymentSuccess', { namespace: 'Payment' }) private verifyPaymentSuccess: boolean;
	@Action('getRecurringPolicies', { namespace: 'Payment' }) private getRecurringPolicies: any;
	private loading: boolean = true;
	private stripe: Stripe = null;
	private addPaymentMethodId: string = uuid();
	private alert: { type: string; title: string; msg: string } = null;

	@Watch('alert')
	private watchAlert() {
		if (this.alert !== null) {
			setTimeout(() => {
				this.alert = null;
			}, 10000);
		}
	}

	get paymentMethodSuccess() {
		if (this.addPaymentMethod) {
			return 'Added';
		}

		if (this.removePaymentSuccess) {
			return 'Removed';
		}

		if (this.verifyPaymentSuccess) {
			return 'Verified';
		}
	}

	/**
	 * Builds our 2 column setup and sets the add payment method button at the end.
	 */
	get buildMethodRows() {
		// Recreate the array everytime something changes so we can always add the Add Payment Method at the end.
		const paymentSources = [...this.paymentSources];

		paymentSources.push({
			type: 'addMethod',
			addMethod: true,
		});

		return paymentSources.reduce((c, n, i) => {
			if (i % 2 === 0) {
				c.push([]);
			}

			c[c.length - 1].push(n);
			return c;
		}, []);
	}

	public async created() {
		try {
			await Promise.all([this.setPaymentSources(), this.getRecurringPolicies()]);
		} catch (e) {
			captureException(e);
		} finally {
			this.loading = false;
		}

		// Setup Stripe
		console.log(Brand.getStripeKey());
		this.stripe = await loadStripe(Brand.getStripeKey());
	}

	private addPaymentMethod() {
		jQuery('#addPaymentMethod').modal('show');
	}
}
